import { jsx as _jsx } from "react/jsx-runtime";
// Copyright 1999-2023. Plesk International GmbH. All rights reserved.
/* eslint-disable react/no-unused-prop-types */

/**
 * `Tab` is an individual element of the [Tabs](#!/Tabs) component.
 *
 * Each `Tab` can display an icon near the tab name for easier identification.
 * It can also display a [Label](#!/Label) next to the tab name for showing additional information about its content.
 * You can make `Tabs` closeable, for example, if you are using them for opening and displaying files.
 * @since 0.0.35
 */
const Tab = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    children: children
  });
};
export default Tab;